var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "chart", staticClass: "chart" },
    [
      _c("e-chart", {
        attrs: {
          options: _vm.options,
          "auto-resize": true,
          height: _vm.height,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }